import React, { Component } from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { Field, reduxForm } from "redux-form";
import withStyles from "isomorphic-style-loader/withStyles";
import { connect } from "react-redux";
import Form from "react-bootstrap/lib/Form";
import Button from "react-bootstrap/lib/Button";
import cx from "classnames";

import PlaceGeoSuggest from "../../Common/GeoSuggest/PlaceGeoSuggest";
import { setPersonalizedValues } from '../../../actions/personalized';
import { openSimplifiedFiltersModal } from '../../../actions/modalActions';
import { change } from "redux-form";
import history from "../../../core/history";
import { handleMobileSearchChange, handleMobileSelectSuggest } from '../../../helpers/GeoSuggest/updateSearchForm';

import filterIcon from '/public/SiteIcons/moreFilterIcon.svg';
import messages from "../../../locale/messages";
import s from "./MobileLocationSearch.css";

class MobileLocationSearch extends Component {

  handleClick = () => {
    const { personalized } = this.props;
    let updatedURI, uri = '/s?';
    if (personalized.location) {
      uri = uri + '&address=' + personalized.location;
    }
    if (personalized.chosen) {
      uri = uri + '&chosen=' + personalized.chosen;
    }
    updatedURI = encodeURI(uri);
    history.push(updatedURI);
  }

  handleOpen = () => {
    const { openSimplifiedFiltersModal } = this.props;
    openSimplifiedFiltersModal();
  }

  onSuggestSelect = (data, value) => {
    const { setPersonalizedValues } = this.props;
    handleMobileSelectSuggest({ change, handleSubmit: this.handleClick, setPersonalizedValues, data, value });
  }

  onChange = async (value) => {
    const { setPersonalizedValues, change } = this.props;
    if (value == '') {
      handleMobileSearchChange({ change, handleSubmit: this.handleClick, setPersonalizedValues, value });
    }
  }

  renderPlacesSuggest = ({ input, label }) => {
    const { personalized } = this.props;
    return (
      <PlaceGeoSuggest
        placeholder={label}
        onChange={this.onChange}
        onSuggestSelect={this.onSuggestSelect}
        id={'mobileLocationSearch'}
        initialValue={personalized.location}
        className='searchHeaderPlaceSuggest'
        containerClass="mobileSearchHeaderGeoSuggest"
      />
    )
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { formValues } = this.props;

    let isActiveMoreFilter = false;
    if (
      (formValues?.beds ||
        formValues?.bedrooms ||
        formValues?.bathrooms ||
        formValues?.amenities?.length ||
        formValues?.safetyAmenities?.length ||
        formValues?.spaces?.length ||
        formValues?.houseRules?.length ||
        formValues?.bookingType == "instant" ||
        formValues?.priceRange ||
        formValues?.dates ||
        formValues?.personCapacity > 1
      )
    ) {
      isActiveMoreFilter = true;
    }

    return (
      <div className={s.mobileLocationSearchContainer}>
        <div className={cx(s.mobileSearchHeader, 'mobileSearchHeader')}>
          <Form>
            <Field
              name="placeSuggest"
              component={this.renderPlacesSuggest}
              autoComplete="off"
              label={formatMessage(messages.homeWhere)}
            />
          </Form>
          <Button
            className={cx(s.filterBtn, isActiveMoreFilter && s.filterBtnIsActive)}
            onClick={this.handleOpen}
          >
            <span className={cx(s.btnFlex, 'svgImg')}>
              <span className="hidden-xs"><FormattedMessage {...messages.filters} /></span>
              <img src={filterIcon} />
            </span>
          </Button>
        </div>
      </div>
    );
  }
}

MobileLocationSearch = reduxForm({
  form: "MobileLocationSearchForm",
  destroyOnUnmount: false,
})(MobileLocationSearch);

const mapState = (state) => ({
  personalized: state?.personalized,
  formValues: state?.form?.SearchForm?.values,
});

const mapDispatch = {
  change,
  setPersonalizedValues,
  openSimplifiedFiltersModal
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(MobileLocationSearch)));
